module.exports = __webpack_public_path__ + "images/emoji/notebook.ffa2c2210ee788b502dd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/notebook.png
// module id = APH8
// module chunks = 13